import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd03c7ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "coupon-list-wrapper" }
const _hoisted_2 = { class: "navbar g-fixed large-top" }
const _hoisted_3 = { class: "coupon-container" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "coupon-content" }
const _hoisted_7 = { class: "coupon-icon" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "coupon-info" }
const _hoisted_10 = { class: "coupon-title" }
const _hoisted_11 = { class: "coupon-condition" }
const _hoisted_12 = { class: "limit" }
const _hoisted_13 = { class: "express-tag" }
const _hoisted_14 = { class: "coupon-footer" }
const _hoisted_15 = { class: "date" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", null, "查看详情", -1))
const _hoisted_18 = {
  key: 1,
  class: "is-expired-icon"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://res-cn.public.gblinker.com/gblinker/wechat_mini/images/2bb45916794124676275e35d17838ae3.png" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "empty-coupon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_PageContainer = _resolveComponent("PageContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["navbar-item", { active: _ctx.couponStatus === 'available' }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchCouponTab && _ctx.switchCouponTab(...args))),
        "data-status": "available"
      }, " 可使用 ", 2),
      _createElementVNode("div", {
        class: _normalizeClass(["navbar-item", { active: _ctx.couponStatus === 'expiration' }]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.switchCouponTab && _ctx.switchCouponTab(...args))),
        "data-status": "expiration"
      }, " 已失效 ", 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_PageContainer, {
        class: "container coupon-wrapper",
        onNextPage: _ctx.getPageData
      }, {
        default: _withCtx(() => [
          (_ctx.couponList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.couponList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "coupon-card",
                    key: item.id,
                    onClick: ($event: any) => (_ctx.selectPackage(item))
                  }, [
                    (!item.is_expiration)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "goto-ordering",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.gotoOrdering && _ctx.gotoOrdering(...args)))
                        }, " 立即使用 "))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          src: item.icon_url
                        }, null, 8, _hoisted_8)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(item.coupon_name), 1),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(item.transaction_minimum > 0
                        ? '满' + item.transaction_minimum + '元可用'
                        : '无门槛'), 1),
                          _createElementVNode("div", _hoisted_13, _toDisplayString(item.all_express_available ? '全线可用' : '部分线路可用'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, " 使用时间 " + _toDisplayString(item.effective_time) + "-" + _toDisplayString(item.expiration_time), 1),
                      _createElementVNode("div", {
                        class: "more",
                        onClick: ($event: any) => (_ctx.gotoCouponDetail(item))
                      }, [
                        _hoisted_17,
                        _createVNode(_component_Icon, {
                          class: "icon",
                          icon: "btn_arrow_right"
                        })
                      ], 8, _hoisted_16)
                    ]),
                    (item.is_expiration)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_5))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_21, "暂无优惠券可以使用"))
        ]),
        _: 1
      }, 8, ["onNextPage"])
    ])
  ]))
}